"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _BlogNotificationEmail = _interopRequireDefault(require("./BlogNotificationEmail"));

var _constants = require("./constants");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  byBlogId: (0, _immutable.Map)()
});

var mergeNotificationEmailsForBlog = function mergeNotificationEmailsForBlog(state, action) {
  var blogId = action.payload.props.blogId;
  var currentNotificationEmailsForBlog = state.getIn(['byBlogId', blogId]) || (0, _immutable.Map)();
  return state.setIn(['byBlogId', blogId], currentNotificationEmailsForBlog.withMutations(function (current) {
    action.payload.data.reduce(function (acc, emailNotification) {
      var currentEmail = acc.get(emailNotification[_constants.BLOG_EMAIL_TYPE]);

      if (currentEmail) {
        return acc.set(emailNotification[_constants.BLOG_EMAIL_TYPE], currentEmail.merge(emailNotification));
      }

      return acc.set(emailNotification[_constants.BLOG_EMAIL_TYPE], new _BlogNotificationEmail.default(emailNotification));
    }, current);
  }));
};

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchNotificationEmailsActionTypes.SUCCESS, function (state, action) {
  return mergeNotificationEmailsForBlog(state, action);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchNotificationEmailDataActionTypes.SUCCESS, function (state, action) {
  return state.setIn(['byBlogId', action.payload.data.subscription_blog_id, action.payload.data.blog_email_type], new _BlogNotificationEmail.default(action.payload.data).merge(state.getIn(['byBlogId', action.payload.data.subscription_blog_id, action.payload.data.blog_email_type])));
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateNotificationEmailsActionTypes.SUCCESS, function (state, action) {
  return mergeNotificationEmailsForBlog(state, action);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;